import { fetchOrgsListAll } from '@vt/apis/lib-ex/v2/orgs'
import { listToTree } from '@ow/utils'
import { filter } from 'lodash-es'
import Base from './base'

export default class Org extends Base {
  constructor(appId, tbNameId, vtProject) {
    super(appId, tbNameId, vtProject)
    this.idFiledName = 'id'
    this.dbSpecPrefix = 'tbi_orgs'
  }

  fetchAll() {
    return fetchOrgsListAll(this.appId).then(async (data) => {
      await this.store(data)
      this.data = data // 临时这么处理，防止每次预处理用户的数据都要请求一次
      this.scope = 'all'
      return data
    })
  }

  fetchOrgs() {
    return fetchOrgsListAll(this.appId).then((data) => {
      return data
    })
  }

  fetchTreeData() {
    return this.fetchAll().then((data) => {
      return listToTree(data)
    })
  }

  fetchByIds(ids) {
    if (!ids) {
      return Promise.all([])
    }
    if (this.scope === 'all') {
      return Promise.all(
        filter(this.data, (d) => ids.includes(d[this.idFiledName]))
      )
    }
    return this.fetchAll().then((data) => {
      return filter(data, (d) => ids.includes(d[this.idFiledName]))
    })
  }
}

Org.modelName = 'org'
